// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import { deleteLine, getAllLines, getLine, updateLine } from '../../helpers/backend_helper';
import { fetchLinesFailure, fetchLinesSuccess, updateLineFailure, updateLineSuccess } from './actions';
import { deleteLineFailure, deleteLineSuccess, fetchLineFailure, fetchLineSuccess } from '../actions';
import { DELETE_LINES_REQUEST, FETCH_LINES_REQUEST, FETCH_LINE_REQUEST, UPDATE_LINES_REQUEST } from './actionTypes';
import { reduxSerializedError } from '../../utils/utils';

function* fetchLinesSaga() {
  try {
    const response = yield call(getAllLines);

    // Store the mapping in localStorage
    yield put(fetchLinesSuccess(response.data));
  } catch (error) {
    yield put(fetchLinesFailure(reduxSerializedError(error)));
  }
}

function* fetchLineSaga({ payload }) {
  try {
    const response = yield call(getLine, payload);
    yield put(fetchLineSuccess(response));
  } catch (error) {
    yield put(fetchLineFailure(reduxSerializedError(error)));
  }
}

function* deleteLinesSaga({ payload }) {
  try {
    yield call(deleteLine, payload);
    yield put(deleteLineSuccess(payload));
    yield call(fetchLinesSaga);
  } catch (error) {
    yield put(deleteLineFailure(reduxSerializedError(error)));
  }
}

function* updateLineSaga({ payload }) {
  const { project } = payload;
  try {
    yield call(updateLine, project);
    yield put(updateLineSuccess());
    yield call(fetchLinesSaga); 
  } catch (error) {
    yield put(updateLineFailure(reduxSerializedError(error)));
  }
}


export default function* rootSaga() {
  yield takeEvery(FETCH_LINES_REQUEST, fetchLinesSaga);
  yield takeEvery(FETCH_LINE_REQUEST, fetchLineSaga);
  yield takeEvery(UPDATE_LINES_REQUEST, updateLineSaga);
  yield takeEvery(DELETE_LINES_REQUEST, deleteLinesSaga);
}
